export default "__VITE_ASSET__CmF0Y8QD__"